import {
  delRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../connection/network";
import { socket } from "../connection/socket";

const timelineApis = {
  list: "page",
  single: "page/s",
  posts: "page/post",
  comment: "page/post/comment",
  invitation: "page/request",
  reply: "page/post/comment/reply",
  members: "page/members",
  speakers: "page/speakers",
  speakerEvent: "page/speakers/events",
  sponsors: "page/sponsors",
  bot: "page/bot",
  pageCovers: "page/covers",
  tabs: "page/tabs",
  analytics: "page/stats",
  rate: "page/rate",
  bookMark: "page/bookMark",
  reservations: "page/reservation",
  booking: "page/reservation/booking",
  canceling: "page/reservation/booking/reason",
  contactUs: "/page/contact-us",
  dynamicTab: "page/pageTabs",
  order: "page/pageTabs/order",
  tabTypes: { list: "page/pageTabs/types", create: "page/pageTabs/types/page" },
  tabDataTypes: "page/pageTabs/datatypes",
  dataTypeValidParams: "page/pageTabs/datatypes/validParams",
};
const paramApis = {
  1: "page/types/page",
  2: "page/fileTypes/page",
  3: "page/memberTypes/page",
  4: "page/sponsors/types/page",
  5: "poll/types/page",
  6: "event/types/page",
  7: "task/types/page",
  8: "stage/types/page",
  9: "halls/types/page",
  10: "store/types/page",
  11: "community-home/types/page",
};
const categoryApis = {
  1: "page/types/page",
  3: "page/memberCategory",
  4: "page/sponsors/organizationCategory",
  5: "poll/pollCategory",
  6: "event/eventCategory",
};

export const getContactUsMessagesService = async ({ query, cb }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await getRequest({
      query,
      endPoint: timelineApis.contactUs,
      token,
    });
    if (cb) {
      cb(null, data);
    }
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    if (cb) {
      cb(sError);
    }
    return { error: sError };
  }
};
export const sendContactUsPageMessageService = async ({ sendData, cb }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await postRequest({
      body: sendData,
      endPoint: timelineApis.contactUs,
      token,
    });
    if (cb) {
      cb(null, data);
    }
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    if (cb) {
      cb(sError);
    }
    return { error: sError };
  }
};
export const updatePageTabsService = async ({ sendData, cb }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await putRequest({
      body: sendData,
      endPoint: timelineApis.tabs,
      token,
    });
    if (cb) {
      cb(data);
    }
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    if (cb) {
      cb(sError);
    }
    return { error: sError };
  }
};

export const createTabService = async ({ sendData, cb }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await postRequest({
      body: sendData,
      endPoint: timelineApis.dynamicTab,
      token,
    });
    if (cb) {
      cb(data);
    }
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    if (cb) {
      cb(sError);
    }
    return { error: sError };
  }
};

export const deleteTabService = async ({ sendData, cb }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await delRequest({
      query: sendData,
      endPoint: timelineApis.dynamicTab,
      token,
    });
    if (cb) {
      cb(data);
    }
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to delete tab";
    if (cb) {
      cb(sError);
    }
    return { error: sError };
  }
};

export const updateDynamicTabService = async ({ sendData, cb }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await putRequest({
      body: sendData,
      endPoint: timelineApis.dynamicTab,
      token,
    });
    if (cb) {
      cb(data);
    }
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    if (cb) {
      cb(sError);
    }
    return { error: sError };
  }
};

export const orderTabService = async ({ sendData, cb }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await putRequest({
      body: sendData,
      endPoint: timelineApis.order,
      token,
    });
    if (cb) {
      cb(data);
    }
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    if (cb) {
      cb(sError);
    }
    return { error: sError };
  }
};

export const createTabTypeService = async ({ sendData, cb }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await postRequest({
      body: sendData,
      endPoint: timelineApis.tabTypes?.create,
      token,
    });
    if (cb) {
      cb(data);
    }
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    if (cb) {
      cb(sError);
    }
    return { error: sError };
  }
};

export const createParamService = async ({ sendData, cb, dTypeId }) => {
  try {
    const token = localStorage.getItem("token");
    if (dTypeId === 5) {
      sendData.pollType = 1;
    }
    if (dTypeId === 3) {
      sendData.name = { en: sendData.name, ar: sendData.name };
    }
    let {
      data: { data, message },
    } = await postRequest({
      body: sendData,
      endPoint: paramApis[dTypeId],
      token,
    });
    if (cb) {
      cb(data);
    }
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    if (cb) {
      cb(sError);
    }
    return { error: sError };
  }
};
export const getCategoryService = async ({ dTypeId, pageId }) => {
  try {
    const token = localStorage.getItem("token");
    let sendDate = { pageId, page: 1, limit: 50 };
    let {
      data: { data, message },
    } = await getRequest({
      query: sendDate,
      endPoint: categoryApis[dTypeId],
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};
export const createCategoryService = async ({ sendData, cb, dTypeId }) => {
  try {
    const token = localStorage.getItem("token");

    let {
      data: { data, message },
    } = await postRequest({
      body: sendData,
      endPoint: categoryApis[dTypeId],
      token,
    });
    if (cb) {
      cb(data);
    }
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    if (cb) {
      cb(sError);
    }
    return { error: sError };
  }
};

export const getTabTypesService = async ({ pageId, limit, page }) => {
  try {
    const token = localStorage.getItem("token");

    const {
      data: {
        data,
        meta: { thisPage, nextPage },
      },
    } = await getRequest({
      query: {
        pageId,
        limit,
        page,
      },
      token,
      endPoint: timelineApis.tabTypes?.list,
    });

    return {
      data,
      thisPage: parseInt(thisPage),
      nextPage: parseInt(nextPage),
    };
  } catch (error) {
    const sError = error?.response?.data?.error?.message;
    return { error: sError };
  }
};

export const getTabDataTypesService = async () => {
  try {
    const token = localStorage.getItem("token");

    const {
      data: { data },
    } = await getRequest({
      token,
      endPoint: timelineApis.tabDataTypes,
    });

    return data;
  } catch (error) {
    const sError = error?.response?.data?.error?.message;
    return { error: sError };
  }
};

export const getDataTypeValidParamsService = async ({ dTypeName }) => {
  try {
    const token = localStorage.getItem("token");

    const {
      data: { data },
    } = await getRequest({
      token,
      endPoint: timelineApis.dataTypeValidParams,
      params: dTypeName,
    });

    return data;
  } catch (error) {
    const sError = error?.response?.data?.error?.message;
    return { error: sError };
  }
};

export const updatePageCoversService = async ({ sendData, cb }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await putRequest({
      body: sendData,
      endPoint: timelineApis.pageCovers,
      token,
    });
    if (cb) {
      cb(data);
    }
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    if (cb) {
      cb(sError);
    }
    return { error: sError };
  }
};
export const createPageService = async ({
  title,
  categoryId,
  description,
  coverPhotos = [],
  industryId,
  image,
  type,
}) => {
  try {
    const sendData = new FormData();
    image && sendData.append("image", image?.file);
    categoryId && sendData.append("categoryId", categoryId);
    industryId && sendData.append("industryId", industryId);
    coverPhotos?.length &&
      coverPhotos?.map((file) => {
        return sendData.append("coverPhotos", file?.file);
      });
    title && sendData.append("title", title);
    description && sendData.append("description", description);
    type && sendData.append("type", type);

    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await postRequest({
      body: sendData,
      endPoint: timelineApis.list,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const updatePageDataService = async ({ data: sendData }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await putRequest({
      body: sendData,
      endPoint: timelineApis.list,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const getCommunityService = async ({ page, limit, text }) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: { data },
    } = await getRequest({
      token,
      query: {
        page,
        limit,
        text,
      },
      endPoint: timelineApis.list + "/community-cats",
    });

    return {
      data,
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const getIndustriesService = async ({ page, limit, text }) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: { data },
    } = await getRequest({
      token,
      query: {
        page,
        limit,
        text,
      },
      endPoint: timelineApis.list + "/community-inds",
    });

    return {
      data,
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const postReact = ({
  postId,
  deleteReact = false,
  reactionTypeId,
  cb,
}) => {
  socket.sendMessage(
    "post_react",
    { reactionTypeId, postId, deleteReact },
    (callBack) => {
      if (cb) cb();
    }
  );
};

export const listPagesService = async ({
  page,
  limit,
  text,
  companyId,
  categoryId,
  joined,
}) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: {
        data,
        meta: { thisPage, allPages },
      },
    } = await getRequest({
      token,
      query: {
        page,
        limit,
        text,
        companyId: companyId || undefined,
        categoryId,
        joined,
      },
      endPoint: timelineApis.list,
    });

    return {
      data,
      thisPage: parseInt(thisPage),
      allPages: parseInt(allPages),
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const getSinglePageService = async ({ pageId }) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: { data },
    } = await getRequest({
      token,
      endPoint: timelineApis.single,
      params: pageId,
    });

    return {
      data,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const getPageBotService = async ({ pageId }) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: { data },
    } = await getRequest({
      token,
      endPoint: timelineApis.bot,
      query: { pageId },
    });

    return {
      data,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const getPostsService = async ({
  pageId,
  limit,
  page,
  categoryId,
  type,
  text,
  sortBy,
  mediaType,
  selectedDay,
  postTypeId,
  pollTypeId,
  fileTypeId,
  eventTypeId,
  contactPosts,
  myId,
  pollCategoryId,
  eventCategoryId,
  startDate,
  dateWithIn,
}) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: {
        data,
        meta: { thisPage, allPages, count },
      },
    } = await getRequest({
      token,
      query: {
        pageId,
        limit,
        page,
        categoryId,
        type,
        text,
        sortBy,
        mediaType,
        selectedDay,
        postTypeId,
        pollTypeId,
        fileTypeId,
        eventTypeId,
        contactPosts,
        myId,
        pollCategoryId,
        eventCategoryId,
        startDate,
        dateWithIn,
      },
      endPoint: timelineApis.posts,
    });

    return {
      data,
      thisPage: parseInt(thisPage),
      allPages: parseInt(allPages),
      hasMore: thisPage !== allPages,
      count,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const createNewPostService = async ({
  files,
  text,
  pageId,
  categoryId,
  postTypeId,
  fileTypeId,
}) => {
  try {
    const sendData = new FormData();
    sendData.append("pageId", pageId);
    files?.map((file) => {
      return sendData.append("files", file?.file);
    });
    text && sendData.append("text", text);
    categoryId && sendData.append("categoryId", categoryId);
    postTypeId && sendData.append("postTypeId", postTypeId);
    fileTypeId && sendData.append("fileTypeId", fileTypeId);
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await postRequest({
      body: sendData,
      endPoint: timelineApis.posts,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const  getCommentsService = async ({ postId, limit, page }) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: {
        meta: { thisPage, allPages },
        data: { comments, post },
      },
    } = await getRequest({
      token,
      query: {
        limit,
        page,
      },
      endPoint: timelineApis.posts,
      params: postId,
    });

    return {
      data: { post, comments },
      thisPage: parseInt(thisPage),
      allPages: parseInt(allPages),
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const createNewCommentService = async ({ files, text, postId }) => {
  try {
    const sendData = new FormData();
    sendData.append("postId", postId);
    files?.map((file) => {
      return sendData.append("files", file?.file);
    });
    text && sendData.append("text", text);
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await postRequest({
      body: sendData,
      endPoint: timelineApis.comment,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const updatePostService = async ({ data: sendData }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await putRequest({
      body: sendData,
      endPoint: timelineApis.posts,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};
export const updateCommentService = async ({ data: sendData }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await putRequest({
      body: sendData,
      endPoint: timelineApis.comment,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const updateReplyService = async ({ data: sendData }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await putRequest({
      body: sendData,
      endPoint: timelineApis.reply,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const sendPageRequestService = async ({ pageId }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await postRequest({
      body: { pageId },
      endPoint: timelineApis.invitation,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};
export const addPageMembersService = async ({ sendData }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await postRequest({
      body: sendData,
      endPoint: timelineApis.members,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const deletePostService = async ({ ids, deleteSession }) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: { data, message },
    } = await delRequest({
      endPoint: timelineApis.posts,
      token,
      query: {
        ids,
        deleteSession,
      },
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};
export const deletePostCommentService = async ({ ids }) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: { data, message },
    } = await delRequest({
      endPoint: timelineApis.comment,
      token,
      query: {
        ids,
      },
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

//Replies
export const createNewReplyService = async ({ files, text, commentId }) => {
  try {
    const sendData = new FormData();
    sendData.append("commentId", commentId);
    files?.map((file) => {
      return sendData.append("files", file?.file);
    });
    text && sendData.append("text", text);
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await postRequest({
      body: sendData,
      endPoint: timelineApis.reply,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const getPageMembersService = async ({
  pageId,
  text,
  page,
  limit,
  memberTypeId,
}) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: {
        meta: { thisPage, allPages, count },
        data,
      },
    } = await getRequest({
      token,
      query: {
        limit,
        page,
        pageId,
        text,
        memberTypeId,
      },
      endPoint: timelineApis.members,
    });

    return {
      data: data,
      thisPage: parseInt(thisPage),
      allPages: parseInt(allPages),
      count: parseInt(count),
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

///SPeakers
export const getPageSpeakersService = async ({
  pageId,
  text,
  page,
  limit,
  specialMemberTypeId,
  specialMemberCategoryId,
}) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: {
        meta: { thisPage, allPages, count },
        data,
      },
    } = await getRequest({
      token,
      query: {
        limit,
        page,
        pageId,
        text,
        specialMemberTypeId,
        specialMemberCategoryId,
      },
      endPoint: timelineApis.speakers,
    });

    return {
      data: data,
      thisPage: parseInt(thisPage),
      allPages: parseInt(allPages),
      count: parseInt(count),
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};
export const addSpeakerService = async ({ sendData }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await postRequest({
      body: sendData,
      endPoint: timelineApis.speakers,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};
export const deleteSpeakerService = async ({ queryData }) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: { data, message },
    } = await delRequest({
      endPoint: timelineApis.speakers,
      token,
      query: queryData,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

///Speakers event
export const addSpeakerEventService = async ({ sendData }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await postRequest({
      body: sendData,
      endPoint: timelineApis.speakerEvent,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};
export const listSpeakerEventService = async ({
  page,
  limit,
  pageSpeakerEventId,
  eventId,
}) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: {
        data,
        meta: { thisPage, allPages },
      },
    } = await getRequest({
      token,
      query: {
        page,
        limit,
        pageSpeakerEventId,
        eventId,
      },
      endPoint: timelineApis.speakerEvent,
    });

    return {
      data,
      thisPage: parseInt(thisPage),
      allPages: parseInt(allPages),
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Unknown error occured";
    return { error: sError };
  }
};
export const deleteSpeakerEventService = async ({ pageSpeakerEventIds }) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: { data, message },
    } = await delRequest({
      endPoint: timelineApis.speakerEvent,
      token,
      query: {
        pageSpeakerEventIds,
      },
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Unkown error occured";
    return { error: sError };
  }
};

///Sponsors
export const getPageSponsorsService = async ({
  pageId,
  text,
  page,
  limit,
  id,
  organizationTypeId,
  organizationCategoryId,
}) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: {
        meta: { thisPage, allPages, count },
        data,
      },
    } = await getRequest({
      token,
      query: {
        limit,
        page,
        pageId,
        text,
        id,
        organizationTypeId,
        organizationCategoryId,
      },
      endPoint: timelineApis.sponsors,
    });

    return {
      data: data,
      thisPage: parseInt(thisPage),
      allPages: parseInt(allPages),
      count: parseInt(count),
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const addSponsorService = async ({ sendData }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await postRequest({
      body: sendData,
      endPoint: timelineApis.sponsors,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const editSponsorService = async ({ sendData }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await putRequest({
      body: sendData,
      endPoint: timelineApis.sponsors,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const deleteSponsorService = async ({ queryData }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await delRequest({
      query: queryData,
      endPoint: timelineApis.sponsors,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const getPageAnalyticsService = async ({ type, pageId }) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: { data },
    } = await getRequest({
      token,
      query: {
        type,
        pageId,
      },
      endPoint: timelineApis.analytics,
    });

    return {
      data: data,
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const addPageItemRateService = async ({ type, entityId, rate }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await putRequest({
      body: { type, entityId, rate },
      endPoint: timelineApis.rate,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const addPageItemBookmarkService = async ({ type, entityId }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await putRequest({
      body: { type, entityId },
      endPoint: timelineApis.bookMark,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};
export const deletePageBookmarkService = async ({ bookMarkId }) => {
  try {
    const token = localStorage.getItem("token");
    let {
      data: { data, message },
    } = await delRequest({
      query: { bookMarkId },
      endPoint: timelineApis.bookMark,
      token,
    });
    return {
      data,
      message,
    };
  } catch (error) {
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

///Reservation

export const getPageReservationsService = async ({
  pageId,
  page,
  limit,
  isUser,
  userId,
}) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: {
        meta: { thisPage, allPages, count },
        data,
      },
    } = await getRequest({
      token,
      query: {
        limit,
        page,
        pageId,
        isUser,
        userId,
      },
      endPoint: timelineApis.reservations,
    });

    return {
      data: data,
      thisPage: parseInt(thisPage),
      allPages: parseInt(allPages),
      count: parseInt(count),
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const createPageReservationsService = async (sendDate) => {
  try {
    const token = localStorage.getItem("token");

    const {
      data: { data },
    } = await postRequest({
      token,
      body: { ...sendDate },
      endPoint: timelineApis.reservations,
    });

    return {
      data: data,
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const editPageReservationsService = async (sendDate) => {
  try {
    const token = localStorage.getItem("token");

    const {
      data: { data },
    } = await putRequest({
      token,
      body: { ...sendDate },
      endPoint: timelineApis.reservations,
    });

    return {
      data: data,
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const deletePageReservationsService = async (reservationId) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: { data },
    } = await delRequest({
      token,
      query: { reservationId },
      endPoint: timelineApis.reservations,
    });

    return {
      data: data,
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

// Booking

export const getPageReservationsBookingService = async ({
  pageId,
  page,
  limit,
  isUser,
  bookingId,
  reservationId,
}) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: {
        meta: { thisPage, allPages, count },
        data,
      },
    } = await getRequest({
      token,
      query: {
        limit,
        page,
        isUser,
        bookingId,
        reservationId,
        pageId,
      },
      endPoint: timelineApis.booking,
    });
    return {
      data: data,
      thisPage: parseInt(thisPage),
      allPages: parseInt(allPages),
      count: parseInt(count),
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const createPageReservationsBookingService = async (sendDate) => {
  try {
    const token = localStorage.getItem("token");

    const {
      data: { data },
    } = await postRequest({
      token,
      body: { ...sendDate },
      endPoint: timelineApis.booking,
    });

    return {
      data: data,
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const editPageReservationsBookingService = async (sendDate) => {
  try {
    const token = localStorage.getItem("token");

    const {
      data: { data },
    } = await putRequest({
      token,
      body: { ...sendDate },
      endPoint: timelineApis.booking,
    });

    return {
      data: data,
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const deletePageReservationsBookingService = async (bookingId) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: { data },
    } = await delRequest({
      token,
      query: { bookingId },
      endPoint: timelineApis.booking,
    });

    return {
      data: data,
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};

export const cancelPageReservationsService = async (sendDate) => {
  try {
    const token = localStorage.getItem("token");
    const {
      data: { data },
    } = await putRequest({
      token,
      body: { ...sendDate },
      endPoint: timelineApis.canceling,
    });

    return {
      data: data,
    };
  } catch (error) {
    console.error(error);
    const sError =
      error?.response?.data?.error?.message || "Failed to get data";
    return { error: sError };
  }
};
